import { useCallback } from 'react'
import { css } from '@emotion/react'
import CollapsableCard from 'components/CollapsableCard'
import { Button } from 'util/ui'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_INTEGRATION_INSTALL } from 'ducks/drawers/types'
import { doSetFlag } from 'ducks/flags'
import logo from 'assets/integrations/shopify.png'

const ShopifyInstall = ({ showInstall }) => {
  const handleDismiss = () => {
    doSetFlag('hide-shopify-v2-sidebar-install', true)
  }
  const { openDrawer: openInstallShopifyDrawer } = useDrawer(
    DRAWER_TYPE_INTEGRATION_INSTALL
  )
  const handleClick = useCallback(
    () => openInstallShopifyDrawer('SHOPIFY_V2'),
    [openInstallShopifyDrawer]
  )

  if (!showInstall) return null

  return (
    <CollapsableCard
      isLoading={false}
      persistenceKey="customWidget.shopify_install"
      title="Connect Shopify"
      image={logo}
      css={css`
        color: var(--color-monochrome-superDark);
      `}
    >
      <p>
        Manage your Shopify support right from your Groove {app.t('mailbox')}!
      </p>
      <ul
        css={css`
          margin-bottom: 20px;
        `}
      >
        <li>See customer details &amp; timeline</li>
        <li>View customer orders &amp; statuses</li>
        <li>Handle returns &amp; cancellations</li>
        <li>Create new customer orders</li>
        <li>Easy lookup for your store products</li>
      </ul>
      <div>
        <Button primary onClick={handleClick}>
          Connect Shopify
        </Button>
        <Button basic onClick={handleDismiss}>
          Dismiss
        </Button>
      </div>
    </CollapsableCard>
  )
}

export default ShopifyInstall
